<div class="container admin-level">
  <div class="row users-toolbar">
    <div class="col-auto">
      <mat-form-field>
        <label>{{ 'Sök användare' | translate }}</label>
        <input matInput [(ngModel)]="filter">
      </mat-form-field>
    </div>
    <div class="col-auto user-visibility-preferences">
      <mat-checkbox [(ngModel)]="showDisabledUsers" color="primary">{{ 'Visa inaktiverade användare' | translate }}</mat-checkbox>
    </div>
    <div class="col align-right">
      <button mat-raised-button color="primary" (click)="fetchUsers()">{{ 'Uppdatera' | translate }}</button>
    </div>
  </div>

  <table class="fullwidth styled users" *ngIf="users">
    <tr>
      <th>{{ 'Användarnamn' | translate }}</th>
      <th>{{ 'Namn' | translate }}</th>
      <th>{{ 'Roll' | translate }}</th>
      <th>{{ 'Källa' | translate }}</th>
      <th class="align-center">{{ 'Använd Shopify-tema' | translate }}</th>
      <th></th>
    </tr>
    <tr *ngFor="let user of displayedUsers()" [ngClass]="{'disabled': user.disabled}">
      <td>{{user.username}}</td>
      <td>{{user.name}}</td>
      <td>{{user.role}}</td>
      <td>{{user.source}}</td>
      <td class="align-center">
        <mat-checkbox color="primary" [(ngModel)]="user.settings.useShopifyTheme"
          [disabled]="savingUserIds[user._id]" (change)="settingsChanged(user)"></mat-checkbox>
      </td>
      <td class="align-right status">
        <span *ngIf="savingUserIds[user._id]">{{ 'Sparar...' | translate }}</span>
        <span class="negative-foreground" *ngIf="errorUserIds[user._id]">{{ 'Kunde inte sparas' | translate }}</span>
      </td>
    </tr>
  </table>

  <p *ngIf="users && !displayedUsers().length">{{ 'Inga användare hittades' | translate }}</p>
</div>
